import { createContext } from 'react';
export var SelectOptionContext = /*#__PURE__*/createContext({
  multiSelect: false,
  value: []
});